<template>
    <Head title="Categories"/>
    <list-page-template
        name="Categories"
        route="categories.index"
        :filters="filters" v-model:sort="currentSort" :sort-options="sortOptions" v-model:active-filters="activeFilters"
        description="Manage image categories">
        <h2 id="products-heading" class="sr-only">Categories</h2>
        <div class="flex flex-col">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Made by System</th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                            </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="category in pagination.data" class="cursor-pointer" :key="category.id">
                                <td class="px-6 py-4 whitespace-nowrap ">
                                    <div class="text-sm text-gray-900">{{ category.name }}</div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <span
                                        :class="category.is_system ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'"
                                        class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"> {{ category.is_system ? "Yes" : "No" }} </span>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    <div class="text-sm text-gray-900">{{ category.price.toFixed(2).toLocaleString() }}</div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <pagination :pagination="this.pagination" />
    </list-page-template>
</template>

<script>
import Layout from '@/Shared/Layout'
import { isProxy, toRaw } from "vue"
import Pagination from '@/Shared/Pagination'
import { Head } from "@inertiajs/inertia-vue3";
import ListPageTemplate from "@/Shared/PageSegments/ListPageTemplate";

export default {
    layout: Layout,
    props: {
        auth: Object,
        sort: String,
        filters: Object,
        pagination: Object,
        sortOptions: Object,
        filterOptions: Object,
    },
    components: {
        Head,
        Pagination,
        ListPageTemplate,
    },
    data() {
        return {
            currentSort: this.sort ?? '',
            activeFilters: []
        }
    },
    setup(props) {
        return {
            sortOptions: isProxy(props.sortOptions) ? toRaw(props.sortOptions) : props.sortOptions,
            filters: isProxy(props.filterOptions) ? toRaw(props.filterOptions) : props.filterOptions,
        }
    },
    methods: {}
}
</script>
